export enum SkipLinkEnum {
  NAVIGATION_MAIN = 'skipLinkMain',
  NAVIGATION_MENU = 'skipLinkMenu',
  NAVIGATION_FOOTER = 'skipLinkFooter',
}

export class SkipLinkEnumTools {
  static convertHashToSkipLink(path: string): SkipLinkEnum | undefined {
    const extractedRoute = path.slice(1);
    if (Object.values(SkipLinkEnum).includes(extractedRoute as SkipLinkEnum)) {
      return extractedRoute as SkipLinkEnum;
    } else {
      return undefined;
    }
  }

  static getSkipLink(link: string): SkipLinkEnum | undefined {
    if (Object.values(SkipLinkEnum).includes(link as SkipLinkEnum)) {
      return link as SkipLinkEnum;
    } else {
      return undefined;
    }
  }
}
